// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"49daba5c","468":"c646de1e","488":"174dfc3a"}[chunkId] + ".chunk.css";
};